import { render, staticRenderFns } from "./RegisterSteps.vue?vue&type=template&id=66cf66c6&scoped=true&"
import script from "./RegisterSteps.vue?vue&type=script&lang=js&"
export * from "./RegisterSteps.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSteps.vue?vue&type=style&index=0&id=66cf66c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf66c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VStepper,VStepperContent,VStepperItems})
